import { Navigate } from 'react-router-dom'
import { isAuthenticated } from '../services/authService'
import { getStoredApiKey } from '../services/apiKeyService'

function ProtectedRoute({ children }) {
  const apiKey = getStoredApiKey()
  const authenticated = apiKey || isAuthenticated()

  if (!authenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default ProtectedRoute

